import React, { FunctionComponent, useContext } from "react";
import styled from "styled-components";
import Context from "../context/Context";

const Footer: FunctionComponent = (props: any) => {
  const data: { hashtag: string } = useContext(Context);
  const { hashtag } = data;

  return (
    <StyledPrivacy className={props.className}>
      <a
        href="https://scoopnewsgroup.com/privacy/"
        target="_blank"
        className={props.className}
      >
        Privacy Policy
      </a>
    </StyledPrivacy>
  );
};

const StyledPrivacy = styled.div`
  width: 100%;
  position: relative;
  background-color: transparent;
  bottom: -20px;
  right: 0;
  padding-top: 10px;
  padding-bottom: 10px;

  a {
    text-decoration: none;
    text-align: right;
    float: left;
    font-size: 14px;
    color: #000;
    margin-left: 20px;
  }

  &.black {
    background-color: #000;
    a {
      color: #000;
    }
  }

  @media only screen and (max-width: 503px) {
    bottom: -200px;
  }
`;
export default Footer;
